import * as PropTypes from 'prop-types';
import * as React from 'react';
import AcceptedPaymentMethod from './accepted_payment_method';
import { flatten } from 'lodash';

const DIRECT_CHECKOUT = 'direct_checkout';
const CREDIT_CARD = 'credit-card';
const GIFT_CARD = 'gift-card';

const SUPPORTED_METHODS = [
  'direct_checkout',
  'paypal',
  'affirm',
];

class AcceptedPaymentMethods extends React.Component {
  get acceptedPaymentMethods() {
    return flatten(this.supportedMethods.map((paymentMethod) => {
      if (paymentMethod === DIRECT_CHECKOUT) {
        return [CREDIT_CARD, GIFT_CARD];
      }

      return paymentMethod;
    }));
  }

  get supportedMethods() {
    return this.props.acceptedPaymentMethods.filter(paymentMethod =>
      SUPPORTED_METHODS.includes(paymentMethod));
  }

  renderAcceptedPaymentMethods() {
    return this.acceptedPaymentMethods.map(paymentMethod =>
      <AcceptedPaymentMethod paymentMethod={paymentMethod} key={paymentMethod} />);
  }

  render() {
    if (!this.acceptedPaymentMethods.length) { return false; }

    return (
      <section>
        <div className="module btm-square-module align-center bd-rounded">
          <h1 className="uppercase fine-print mobile-mt-half">
            {I18n.t('acceptedPaymentMethods.acceptedPaymentMethods')}
          </h1>
          <div className="payment-method-icons">
            {this.renderAcceptedPaymentMethods()}
          </div>
        </div>
      </section>
    );
  }
}

AcceptedPaymentMethods.propTypes = {
  acceptedPaymentMethods: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AcceptedPaymentMethods;



// WEBPACK FOOTER //
// ./javascripts/components/accepted_payment_methods/accepted_payment_methods.jsx